import { builder, declareClient } from '@mint-lib/api-zod-support';
import { enqueueSnackbar } from '@mint-lib/notifications-api';

import { isValidNonGet500Error } from './utils.js';

export const guestApi = builder({
  prefixUrl: '/api/',
});
export const guestClient = declareClient({
  api: guestApi,
});
export const accessApi = builder({
  prefixUrl: '/api/',
});
export const accessClient = declareClient({
  api: accessApi,
});
export const defaultApi = builder({
  prefixUrl: '/api/',
  onZodError: import.meta.env.DEV
    ? (error, _, __, response) => {
        console.error(
          `Zod error in request to ${response?.url} ${error.message}`,
        );
      }
    : undefined,
  onError: (error) => {
    // We show a generic error message for unhandled non-get 500 errors
    if (isValidNonGet500Error(error)) {
      enqueueSnackbar({
        variant: 'error',
        title: 'Error',
        subTitle: 'Something went wrong',
        textLayout: 'inline',
      });
    }
  },
});
export const defaultClient = declareClient({
  api: defaultApi,
});
